export const API_PATH = 'https://dev-apigateway.airportr.com/';
export const GET_DATETIME = 'api/System/CurrentUKDateTime';
export const GET_BOOKING_DETAILS = 'api/Booking/BookingDetailsLite';
export const GET_TRACKING_STATUS = 'api/Tracking/GetTrackingStatus';
export const SET_PNR = 'api/DCS/UpdatePNR';
export const GET_DECLARATAION = 'api/PreArrival/GetCustomsDeclarationData';
export const bookingRef = '';
export const SEND_OTP_TO_USER = 'api/PreArrival/SendCustomsDeclarationVerificationCodeSMS';
export const VERIFY_USER_OTP = 'api/PreArrival/ValidateCustomsDeclarationVerificationCode'
export const SOTRE_PRE_ARRIVAL_DATA = 'api/PreArrival/StorePreArrivalData';
export const ADDIATATAGIMAGE = 'api/Image/AddIataTagImage';
export const ADDIATATACODE = 'api/PreArrival/AddIataCode';
export const GetSystemObjects = 'api/System/GetSystemObjects';
export const StorePreAcceptanceData = '/api/PreAcceptance/StorePreAcceptanceData';
export const GET_PASSENGER_RULES_COPY_DATA = 'airlineconfiguration/api/Airline/GetDynamicContent';
export const ADD_IMAGE = 'api/Image/AddImage';

export enum BagsJourneyType {
  Collected = 1,
  InTransit = 2,
  InStorage = 3,
  OutOfStorage = 4,
  CheckedIn = 5,
  Downgraded = 6
}

export enum BagsJourneyStatus {
  Pending = 1,
  InProgress = 2,
  Completed = 3,
  UrgentAttention = 4
}



// WEBPACK FOOTER //
// ./src/globals.ts